import React from "react";

import { getActiveBrand } from "../branding/activeBrand";

export function LogoHeader({
    color,
    logoSrc,
    content,
}) {

    // A per-account header color must show faithfully (as it does for Baintex,
    // which has no header image). The brand's header image is opaque and full
    // bleed, so it would hide the color; only use it when no color is set.
    const backgroundImage = color ? null : getActiveBrand().headerBackgroundImage;

    //VIEW
    return (
        <div
            style={{
                backgroundColor: color || "#202020",
                ...(backgroundImage && {
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: "100% 100%",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }),
            }}
            className={`
                d-flex
                no-gutters
                align-items-center
                justify-content-between
                c-z-index-full
                p-2
            `}
        >
            {logoFn()}
            {content}
        </div>
    );

    function logoFn() {
        return (
            <div className={`
                ml-2
                col-3
                ${backgroundImage ? "py-2" : ""}
                d-flex
                align-items-center
            `}>
                <img
                    src={logoSrc}
                    alt="header_logo"
                    style={{
                        height: backgroundImage ? "1.5rem" : undefined,
                        maxHeight: backgroundImage ? undefined : "2.5rem",
                        width: backgroundImage ? "auto" : undefined,
                        maxWidth: "100%",
                    }}
                />
            </div>
        );
    }
}